/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { isIntegerDependencies } from './dependenciesIsInteger.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createApplyTransform } from '../../factoriesAny.js';
export var applyTransformDependencies = {
  isIntegerDependencies,
  typedDependencies,
  createApplyTransform
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesApplyTransform.generated.js
// module id = 1304
// module chunks = 2